import React, { Component } from 'react';
import './Message.css';

class Message extends Component {
  componentDidMount() {
    this.scrollToBottom();
  }

  timeConverter = () =>
    new Date(this.props.date).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });

  scrollToBottom = () => {
    this.lastMessage.scrollIntoView({ behavior: 'smooth' });
  };

  render() {
    return (
      <div
        ref={el => {
          this.lastMessage = el;
        }}
        className="message-element"
      >
        <div className="message-element-name">{this.props.name}</div>
        <div className="message-element-date">{this.timeConverter()}</div>
        <div className="message-element-content">{this.props.message}</div>
      </div>
    );
  }
}

export default Message;
